import React, { useState } from 'react';
import AllQuestionButton from '../allQuestionsButton/allQuestionButton';

// components
import ChartTitleIntro from '../chartTitleIntro/chartTitleIntro';
import DataMethodLink from '../dataMethodLink/dataMethodLink';
import Chart1 from './chart1/chart1';
import Chart2 from './chart2/chart2';
import Chart3 from './chart3/chart3';

// styles
import './chart3Wrapper.scss';

const Chart3Wrapper = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const handleChangeTab = (index: number) => {
    setSelectedTab(index);
  };

  return (
    <div className="chart3wrapper">
      <ChartTitleIntro number={3} title="Wie ist das Steueraufkommen in der Schweiz verteilt?">
        In den Grafiken 3.1 und 3.2 wird der Anteil der obersten Einkommensgruppen am gesamten Steueraufkommen dargestellt, aufgeschlüsselt nach den
        Kantonen und über die Zeit. Die Steueraufkommensanteile zeigen, wie viel Prozent der Steuern von den jeweiligen Einkommensgruppen gezahlt
        werden. Ein Top-10%-Steueranteil von 55% gibt an, dass die Top-10%-Verdiener 55% der gesamten Einkommensteuern in der Schweiz entrichten. Die
        Grafik 3.3 stellt den Anteil der Haushalte dar, die aufgrund tiefer Einkommen keine Bundessteuer zahlen. Ein Anteil von 25% bedeutet, dass ein
        Viertel der Haushalte von der Bundessteuer befreit ist. Hier erfahren Sie mehr zu <DataMethodLink />.
      </ChartTitleIntro>

      <div className="charttabs">
        <div className="charttabs-tabs tabs-3">
          <div className={`charttabs-tab ${selectedTab === 0 ? 'active' : ''}`} onClick={() => handleChangeTab(0)}>
            3.1 INTERKANTONALER VERGLEICH DER STEUERAUFKOMMENSANTEILE
          </div>
          <div className={`charttabs-tab ${selectedTab === 1 ? 'active' : ''}`} onClick={() => handleChangeTab(1)}>
            3.2 ENTWICKLUNG DER STEUERAUFKOMMENSANTEILE
          </div>
          <div className={`charttabs-tab ${selectedTab === 2 ? 'active' : ''}`} onClick={() => handleChangeTab(2)}>
            3.3 ENTWICKLUNG DER STEUERPFLICHTIGEN OHNE STEUERAUFKOMMEN
          </div>
        </div>
        <div className="charttabs-content">
          <div className={`${selectedTab === 0 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">3.1 INTERKANTONALER VERGLEICH DER STEUERAUFKOMMENSANTEILE</div>
            <Chart1 />
          </div>
          <div className={`${selectedTab === 1 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">3.2 ENTWICKLUNG DER STEUERAUFKOMMENSANTEILE</div>
            <Chart2 />
          </div>
          <div className={`${selectedTab === 2 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">3.3 ENTWICKLUNG DER STEUERPFLICHTIGEN OHNE STEUERAUFKOMMEN</div>
            <Chart3 />
          </div>
        </div>
      </div>
      <div className="d-md-none align-center">
        <AllQuestionButton />
      </div>
    </div>
  );
};

export default Chart3Wrapper;
